import React from "react";
import "./Pager.css";

const PAGE_SIZES = [10, 25, 50];

export default function SearchBox({
    safePage,
    setPage,
    pageCount,
    ...rest
}) {
    return (
        <div className="pager-buttons">
            <div className="admin-table-pager">
                <button
                    className="pager-btn"
                    disabled={safePage <= 1}
                    onClick={() => setPage(p => Math.max(1, p - 1))}
                >
                    ← Prev
                </button>
                <span className="pager-label">
                    Page {safePage} of {pageCount}
                </span>
                <button
                    className="pager-btn"
                    disabled={safePage >= pageCount}
                    onClick={() => setPage(p => Math.min(pageCount, p + 1))}
                >
                    Next →
                </button>
            </div>
        </div>
    );
}